
export { getProductItemParams } from "/app/src/utils/gtagEvents.js"
export { productShow } from "/app/src/utils/gtagEvents.js"